// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    background: #075907 url(https://pmfby.amnex.co.in/pmfby/public/img/CIBack.png);
    background-size: cover;
    color: rgb(184, 233, 134);
    padding: 12px 0 12px 0;
    text-align: center;
    width: 100%;
}
.footer-links{
    display: flex;
    background-color: #fff;
    list-style: none;
    justify-content: center;
    align-items: center;
    padding-block: .75rem;
    border-top: 1px solid #b8e986;
    margin: 0;
}
.footer-links a {
    font-family: var(--fontOpenSans);
    font-size: 13px;
    font-weight: 500;
    padding-inline: .5rem;
    color: #000;
    transition: all .5s;
}
.footer-links a:hover, .footer-links a.active {
    color: #085207;
    text-decoration: underline;
}
.footer p {
    font-size: calc(var(--fs10) + 2px) ;
}
.footer p a {
    color: var(--white);
}

.my-topbreadcrum {
    display: flex;
    list-style: none;
    align-items: center;
    padding: 0;
    margin: 0;
}
.my-topbreadcrum li a:first-child{
    color: rgb(150, 218, 75);
    text-decoration: underline;
    }`, "",{"version":3,"sources":["webpack://./src/component/shared/Footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,8EAA8E;IAC9E,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,6BAA6B;IAC7B,SAAS;AACb;AACA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,SAAS;AACb;AACA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B","sourcesContent":[".footer {\n    background: #075907 url(https://pmfby.amnex.co.in/pmfby/public/img/CIBack.png);\n    background-size: cover;\n    color: rgb(184, 233, 134);\n    padding: 12px 0 12px 0;\n    text-align: center;\n    width: 100%;\n}\n.footer-links{\n    display: flex;\n    background-color: #fff;\n    list-style: none;\n    justify-content: center;\n    align-items: center;\n    padding-block: .75rem;\n    border-top: 1px solid #b8e986;\n    margin: 0;\n}\n.footer-links a {\n    font-family: var(--fontOpenSans);\n    font-size: 13px;\n    font-weight: 500;\n    padding-inline: .5rem;\n    color: #000;\n    transition: all .5s;\n}\n.footer-links a:hover, .footer-links a.active {\n    color: #085207;\n    text-decoration: underline;\n}\n.footer p {\n    font-size: calc(var(--fs10) + 2px) ;\n}\n.footer p a {\n    color: var(--white);\n}\n\n.my-topbreadcrum {\n    display: flex;\n    list-style: none;\n    align-items: center;\n    padding: 0;\n    margin: 0;\n}\n.my-topbreadcrum li a:first-child{\n    color: rgb(150, 218, 75);\n    text-decoration: underline;\n    }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
